var map = {
	"./SDGs.png": "e4c1",
	"./pillars/blueEconomy.png": "0927",
	"./pillars/climateAction.png": "57d9",
	"./pillars/digitalTransformation.png": "4e75",
	"./samoa/0.png": "432a",
	"./samoa/1.png": "eaba",
	"./samoa/10.png": "91f9",
	"./samoa/11.png": "ecde",
	"./samoa/12.png": "8f8c",
	"./samoa/13.png": "6a26",
	"./samoa/14.png": "404e",
	"./samoa/15.png": "b99d",
	"./samoa/16.png": "14cf",
	"./samoa/2.png": "99cb",
	"./samoa/3.png": "0d0e",
	"./samoa/4.png": "51db",
	"./samoa/5.png": "18f8",
	"./samoa/6.png": "7a9d",
	"./samoa/7.png": "4f4d",
	"./samoa/8.png": "2a53",
	"./samoa/9.png": "6f54",
	"./samoaPathway.png": "7ca5",
	"./sdgs/0.png": "20c4",
	"./sdgs/1.png": "031a",
	"./sdgs/10.png": "2263",
	"./sdgs/11.png": "9520",
	"./sdgs/12.png": "5479",
	"./sdgs/13.png": "aa96",
	"./sdgs/14.png": "9da5",
	"./sdgs/15.png": "e854",
	"./sdgs/16.png": "8c9d",
	"./sdgs/17.png": "2a73",
	"./sdgs/2.png": "0129",
	"./sdgs/3.png": "111e",
	"./sdgs/4.png": "197f",
	"./sdgs/5.png": "53c1",
	"./sdgs/6.png": "6faa",
	"./sdgs/7.png": "b562",
	"./sdgs/8.png": "6401",
	"./sdgs/9.png": "1331",
	"./sidsOfferPillars.png": "6aa0",
	"./signature-solutions/1.png": "392d",
	"./signature-solutions/2.png": "7e1a",
	"./signature-solutions/3.png": "5fb7",
	"./signature-solutions/4.png": "e2fc",
	"./signature-solutions/5.png": "4b8b",
	"./signature-solutions/6.png": "d64e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "950a";